import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import { observer, inject } from 'mobx-react';
import { Button, Input } from 'antd';
import { Link } from 'react-router';
import { FormattedMessage, injectIntl } from 'react-intl';
import TmModal from '../../common/TmModal/TmModal';
import { fontSize } from '../../../constants/theme';
import { RowFlex } from '../../common/FlexStyle';
// import Dropdown from '../../common/Dropdown';
import IconSvg from '../../common/IconSvg';
import Spinner from '../../common/spinner';
// import Checkout from '../../Checkout';
// import { SelectLabel } from './styled';

// const { Option } = Dropdown;

@inject('settingsStore')
@injectIntl
@observer
class CourseModalAddOn extends Component {

  constructor(props) {
    super(props);
    this.state = {
      paymentMethod: "",
      wasPurchaseSuccess: false,
      spinnerShown: false,
      couponCode:""
    }
  }

  handlePaymentMethodChange = value => {
    this.setState({ paymentMethod: value });
  };

  handlePayoneerPayment = () => {
    const {
      settingsStore: {
        subscription: { billingPayoneerAccountId },
        connectionManagement: { connectPayoneerAccount },
      }
    } = this.props;

    if (billingPayoneerAccountId === null) {
      connectPayoneerAccount();
    }

    this.setState({ paymentMethod: "payoneer" });
  };

  confirmButtonDisabled = () => {
    const {
      settingsStore: {
        subscription: { billingPaypalAccountId, billingPayoneerAccountId },
      }
    } = this.props;

    const {
      paymentMethod,
    } = this.state;

    if (paymentMethod.length <= 0) {
      return true;
    }

    if (paymentMethod === "paypal" && billingPaypalAccountId !== null) {
      return false;
    }

    if (paymentMethod === "payoneer" && billingPayoneerAccountId !== null) {
      return false;
    }

    return true;
  }

  render() {
    const {
      settingsStore: {
        subscription: {
          isCourseModalOpen,
          setIsCourseModalOpen,
          toggleAddOn,
          purchaseCourse,
          checkUserHasCourse,
          checkCouponCode,
          hasCourseDiscount,
          // billingPaypalAccountId,
          addOns,
        }
      },
    } = this.props;

    const {
      paymentMethod,
      wasPurchaseSuccess,
      spinnerShown,
      couponCode
    } = this.state;
    const coursePrice = addOns.filter(x => x.id === "course")[0]?.plans[0]?.cost;
    const courseDiscount = ((coursePrice * 15) / 100).toFixed(2);

    return (
      <TmModal
        key="course-modal"
        isClosable
        destroyOnClose
        title="Dropshipping Course"
        visible={isCourseModalOpen}
        height
        footer={null}
        onClose={() => {
          toggleAddOn(false, "course");
          this.handlePaymentMethodChange("")
          setIsCourseModalOpen(false);
        }}
        mainActionBtn={!wasPurchaseSuccess && {
          btnType: 'primary',
          text: 'Confirm',
          // eslint-disable-next-line no-unneeded-ternary
          disabled: this.confirmButtonDisabled(),
          clickHandler: () => {
            this.setState({ spinnerShown: true })
            purchaseCourse(paymentMethod,null,hasCourseDiscount ? courseDiscount : 0)
              .then((resp) => {
                if (resp) {
                  checkUserHasCourse();
                  toggleAddOn(true, "course");
                  this.setState({ wasPurchaseSuccess: true });
                  this.setState({ spinnerShown: false })
                } else {
                  this.setState({ wasPurchaseSuccess: true });
                  toggleAddOn(false, "course");
                  this.setState({ spinnerShown: false })
                }
              })
              .catch(() => {
                toggleAddOn(false, "course");
                this.setState({ spinnerShown: false })
              });
          },
        }}
      >
        {spinnerShown && <Spinner />}
        {!wasPurchaseSuccess ? (
          <div
            css={css`
              margin-top: -10px;
              display:flex;
              flex-direction:column;
            `}
          >
            {/* <RowFlex css={css`justify-content:center; font-size:${fontSize.larger};`}>Dropshipping Course</RowFlex> */}
            <RowFlex css={css`font-size:${fontSize.large}; margin-top:10px;`}><FormattedMessage id="course.text" /></RowFlex>
            <RowFlex css={css`font-size:${fontSize.medium}; margin-top:5px;`}><FormattedMessage id="course.line1" /></RowFlex>
            <RowFlex css={css`font-size:${fontSize.medium};`}><FormattedMessage id="course.line2" /></RowFlex>
            <RowFlex css={css`font-size:${fontSize.medium};`}><FormattedMessage id="course.line3" /></RowFlex>
            <RowFlex css={css`font-size:${fontSize.medium};`}><FormattedMessage id="course.line4" /></RowFlex>
            <RowFlex css={css`font-size:${fontSize.medium};`}><FormattedMessage id="course.line5" /></RowFlex>
            <RowFlex css={css`font-size:${fontSize.medium}; margin-bottom:10px`}><FormattedMessage id="course.line6" /></RowFlex>
            <RowFlex style={hasCourseDiscount ? {fontSize:`${fontSize.large}`,textDecoration:'line-through'}:{fontSize:`${fontSize.large}`}}>Course price {coursePrice}$</RowFlex>
            {hasCourseDiscount && (
              <RowFlex css={css`font-size:${fontSize.large};`}>Course price after discount {coursePrice - courseDiscount}$</RowFlex>
            )}
            {!hasCourseDiscount && (
              <RowFlex css={css`font-size:${fontSize.medium};margin-top:10px; margin-bottom:10px;align-items:center;`}>
                <a>Have a coupon?</a>
                <Input type='text' style={{ width: '100px', marginLeft: '10px', marginRight: '10px' }} onChange={(e)=>{this.setState({couponCode:e.target.value})}} />
                <Button onClick={()=>checkCouponCode(couponCode)} type='primary'>Apply</Button>
              </RowFlex>
            )}
            <div
              css={css`
                margin-top: 10px;
                display:flex;
                justify-content:space-evenly;
              `}
            >
              <Button
                id="payoneer"
                cssProps={{
                  padding: 'padding: 0 20px',
                  borderRadius: '20px',
                  marginBottom: '5px',
                  marginRight: '5px',
                }}
                size="large"
                type={paymentMethod === 'payoneer' ? "secondary" : "primary"}
                onClick={() => this.handlePayoneerPayment()}
              >
                <FormattedMessage id="balance.loadViaPayoneer" />
                <IconSvg type="payoneer" size="20" marginLeft="5px" />
              </Button>
              {/* <Button
                cssProps={{
                  padding: 'padding: 0 20px',
                  borderRadius: '20px',
                  marginBottom: '5px',
                  marginRight: '5px',
                }}
                disabled="true"
                size="large"
                type={paymentMethod === 'paypal' ? "secondary" : "primary"}
                // onClick={() => this.handlePaypalMethodChange()}
              >
                <FormattedMessage id="balance.loadViaPaypalComingsoon" />
                <IconSvg type="paypal" size="20" marginLeft="5px" />
              </Button> */}
              <Button
                cssProps={{
                  padding: 'padding: 0 20px',
                  borderRadius: '20px',
                  marginBottom: '5px',
                  marginRight: '5px',
                }}
                size="large"
                type={paymentMethod === 'paypal' ? "secondary" : "primary"}
                onClick={() => this.handlePaymentMethodChange("paypal")}
              >
                <FormattedMessage id="balance.loadViaPaypal" />
                <IconSvg type="paypal" size="20" marginLeft="5px" />
              </Button>
            </div>
            <div css={css`margin-top:15px;`}>
              {paymentMethod === 'paypal' && (
                <PayPalScriptProvider
                  options={{ "client-id": `${process.env.REACT_APP_PAYPAL_CLIENT_ID}` }}
                >
                  <PayPalButtons
                    fundingSource='paypal'
                    createOrder={(data, actions) => {
                      return actions.order.create({
                        purchase_units: [
                          {
                            amount: {
                              // TO DO: hardcode here in case service will be down for some reason we will prevent for paying 0 for course 
                              value: hasCourseDiscount ? coursePrice - courseDiscount :coursePrice
                            },
                          }
                        ]
                      })
                    }}
                    onApprove={(data, actions) => {
                      return actions.order.capture().then((details) => {
                        purchaseCourse(paymentMethod, details.id,hasCourseDiscount ? courseDiscount : 0)
                          .then((resp) => {
                            if (resp) {
                              checkUserHasCourse();
                              toggleAddOn(true, "course");
                              this.setState({ wasPurchaseSuccess: true });
                            } else {
                              this.setState({ wasPurchaseSuccess: true });
                              toggleAddOn(false, "course");
                            }
                          })
                          .catch(() => toggleAddOn(false, "course"));
                        console.log("paypal-response", details)
                      })
                    }}
                  />
                </PayPalScriptProvider>
              )}
            </div>
          </div>
        ) : (
          <div>
            <p>Thank you for purchasing the course. The course is now available in the <Link onClick={() => setIsCourseModalOpen(false)} to="/learning">Online Course</Link> page</p>
          </div>
        )}
      </TmModal>
    );
  }
};

CourseModalAddOn.propTypes = {
  settingsStore: PropTypes.object,
};

export default CourseModalAddOn;